module.exports = {
    block: 'Id',
    systemApiEndpoint: "https://beta-sso.mic.gov.vn/api/system",
    fileApiEndpoint: "https://beta-sso.mic.gov.vn/api/system",
    realTimeEndpoint: "https://rt.sso.aita.gov.vn/systemHub"
};
